import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { Observable } from 'rxjs';

import { ANIMATIONS, TIME_TO_SLIDE } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { Countries } from '@ux/entities/country.enum';
import { MobileDeviceService } from '@app/services/mobile-device.service';

@Component({
  selector: 'app-treatment-personal-data',
  templateUrl: './treatment-personal-data.component.html',
  styleUrls: ['./treatment-personal-data.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TreatmentPersonalDataComponent {

  public animation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public booking: string = 'booking';

  constructor(
    private readonly facade: AppFacade,
    private readonly router: Router,
    private readonly mobileDeviceService: MobileDeviceService,
  ) { }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  public goBack(): void {
    this.animation = ANIMATIONS.SLIDE_OUT_RIGHT;
    setTimeout(() => this.facade.navigateToLastRoute(), TIME_TO_SLIDE);
  }

  get isBookingRoute(): boolean {
    return this.router.url.includes(this.booking);
  }

  get title(): string {
    if (this.isPE) return 'Política de Privacidad de Rappi y Tratamiento de Datos Personales';
    else if (this.isCO || this.isBR || this.isMX) {
      return 'AUTORIZACIÓN TRATAMIENTO DE DATOS PERSONALES TRAVEL MOUSTACHES.A.S.';
    } else if (this.isAR) return 'POLÍTICA DE PRIVACIDAD DE RAPPI';
    else if (this.isCL) return 'AUTORIZACIÓN DEL CLIENTE PARA EL MANEJO DE DATOS PERSONALES';
  }

  get isBR(): boolean {
    return environment.countryInfo.iso_code === Countries.Brazil;
  }

  get isCO(): boolean {
    return environment.countryInfo.iso_code === Countries.Colombia;
  }

  get isMX(): boolean {
    return environment.countryInfo.iso_code === Countries.Mexico;
  }

  get isAR(): boolean {
    return environment.countryInfo.iso_code === Countries.Argentina;
  }

  get isPE(): boolean {
    return environment.countryInfo.iso_code === Countries.Peru;
  }

  get isCL(): boolean {
    return environment.countryInfo.iso_code === Countries.Chile;
  }

}
